import BasePage from "@LandingPage/Scripts/Pages/BasePage";

export default class LightBuilding extends BasePage {
    public static async init() {
        await super.init();

        this.openInfoRequestDialog();
        this.openEventDetails();
        this.openPressDetails();
        this.watchRouteParameters();
        this.setGallery();
    }

    private static openInfoRequestDialog() {
        this.setupUrlParameterButton(".open-dialog", "isVisible");
    }

    private static openEventDetails() {
        this.setupUrlParameterButton(".open-event-details", "isOpenEventDetail");
    }

    private static openPressDetails() {
        this.setupUrlParameterButton(".open-press-details", "isQrCodePress");
    }

    private static setupUrlParameterButton(selector: string, paramName: string) {
        const buttons = document.querySelectorAll(selector);

        buttons.forEach(button => {
            button.addEventListener("click", () => {
                this.updateUrlParameter(paramName, "true");
                this.applyRouteParameters();
            });
        });
    }

    private static updateUrlParameter(paramName: string, value: string) {
        const url = new URL(window.location.href);
        url.searchParams.set(paramName, value);
        window.history.pushState(window.history.state, document.title, url.toString());
    }

    private static watchRouteParameters() {
        const onRouteChange = (event: PopStateEvent) => {
            // Ignora i cambiamenti di route causati da ancore
            const url = new URL(window.location.href);
            if (url.hash) {
                return;
            }
            this.applyRouteParameters();
        };

        window.addEventListener("popstate", onRouteChange);
        this.applyRouteParameters();
    }

    private static applyRouteParameters() {
        const params = new URLSearchParams(window.location.search);

        const showEventDetails = params.get("isOpenEventDetail") === "true";
        const showPressDetails = params.get("isQrCodePress") === "true";

        this.toggleEventDetails(showEventDetails);
        this.togglePressDetails(showPressDetails);
        this.toggleInfoRequestDialog(params.get("isVisible") === "true");

        const landingDescription = document.querySelector(".editor.landing-description");
        if (landingDescription) {
            landingDescription.classList.toggle("hden", showEventDetails || showPressDetails);
        }
    }

    private static toggleEventDetails(shouldShow: boolean) {
        const eventDetails = document.querySelector(".editor.event-details");

        if (!eventDetails) {
            return;
        }

        eventDetails.classList.toggle("hden", !shouldShow);

        if (shouldShow) {
            eventDetails.scrollIntoView({ behavior: "instant", block: "start" });
        }
    }

    private static togglePressDetails(shouldShow: boolean) {
        const pressDetails = document.querySelector(".editor.press-details");

        if (!pressDetails) {
            return;
        }

        pressDetails.classList.toggle("hden", !shouldShow);

        if (shouldShow) {
            pressDetails.scrollIntoView({ behavior: "instant", block: "start" });
        }
    }

    private static toggleInfoRequestDialog(shouldShow: boolean) {
        const store = (<any>window)?.App?.instances?.vm?.$store;
        if (!store) {
            return;
        }

        store.commit("infoRequestStore/setIsDialogVisible", shouldShow);
    }

    private static setGallery() {
        (<any>window).Fancybox.bind("[data-fancybox='gallery']", {
            dragToClose: false,
            caption: (fancybox, slide) => {
                const caption = slide.caption || "";
                return caption;
            },
            Images: {
                zoom: false,
            },
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close'],
                },
            },
            Thumbs: {
                type: 'classic',
            },
        });
    }
}